export const signupVerifyEmailCodeToastId = 'signupVerifyEmailCode';
